function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}
class SectionId {
  static #separator = '__';
  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }
  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }
  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));
    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';
    postProcessCallbacks?.forEach((callback) => callback(newNode));
    setTimeout(() => oldNode.remove(), 500);
  }
  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
  if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });
  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }
  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 992px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }
  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }
    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }
  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}
customElements.define('header-drawer', HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.slider || !this.nextButton) return;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }
  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
    if (this.enableSliderLooping) return;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], -1)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
  isSlideVisible(element, offset = 0) {
    if (!element) return false; 
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }
  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}
customElements.define('slider-component', SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    if (!this.sliderControlWrapper) return;
    // Define sliderItemsToShow here or ensure it's properly initialized
    this.sliderItemsToShow = this.slider.querySelectorAll('.slideshow__slide');
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    // custom code
    this.extraVisibleElement = 0;
    this.sliderItemsToShow.forEach(ele => {
      if(this.isElementVisible(ele)) this.extraVisibleElement++;
    });
    if(this.extraVisibleElement!=0) this.extraVisibleElement--;
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
  // custom code
  isElementVisible(element){
      const rect = element.getBoundingClientRect();
      const rect1 = this.getBoundingClientRect();
      return (
        rect.left >=  rect1.left &&
        rect.right <= rect1.right
      );
    };
  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = (this.currentPage + this.extraVisibleElement) === this.sliderItemsToShow.length; // custom code
    if (!isFirstSlide && !isLastSlide) return;
    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  update() { 
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (this.currentPage > 0 && this.currentPage <= this.sliderControlButtons.length) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }
  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }
  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }
  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }
  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }
  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }
  autoRotateSlides() {
    // custom code
    const slideScrollPosition = (this.currentPage + this.extraVisibleElement) === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }
  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`fieldset`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }
  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define('variant-selects', VariantSelects);
class ProductRecommendations extends HTMLElement {
  observer = undefined;
  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }
  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);
// Account avatar
class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('.icon');
  }
  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }
  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}
customElements.define('account-icon', AccountIcon);
// Scroll To top
let progressScrollValue = () => {
  let scrollProgress = document.getElementById("scroll");
  if (!scrollProgress) {
    return;
  }
  let pos = document.body.scrollTop || document.documentElement.scrollTop;
  let vh = window.innerHeight;
  let calcHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - vh;
  let scrollValue = Math.round((pos * 100) / calcHeight);
  if (pos > vh) {
    scrollProgress.style.opacity = 1;
  } else {
    scrollProgress.style.opacity = 0;
  }
  scrollProgress.style.background = `linear-gradient(to top, rgb(var(--color-button-text)) ${scrollValue}%, rgb(var(--color-button)) ${scrollValue}%)`;
  let arrow = scrollProgress.querySelector("svg path");
  arrow.style.fill = "rgb(var(--color-button-text))";
  if (scrollValue > 50) {
    arrow.style.filter = "invert(1)";
    arrow.style.transition = "fill 0.3s ease, filter 0.3s ease";
  } else {
    arrow.style.filter = "none";
    arrow.style.transition = "fill 0.3s ease, filter 0.3s ease";
  }
  scrollProgress.addEventListener("click", () => {
    document.documentElement.style.scrollBehavior = "smooth";
    document.documentElement.scrollTop = 0;
  });
  scrollProgress.style.setProperty("--scroll-value", `${scrollValue}%`);
};
window.onload = () => {
  progressScrollValue();
};
window.onscroll = () => {
  progressScrollValue();
};
// let progressScrollValue = () => {
//   let scrollProgress = document.getElementById("scroll");
//   if (!scrollProgress) {
//     return;
//   }
//   let pos = document.documentElement.scrollTop;
//   let calcHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
//   let scrollValue = Math.round((pos * 100) / calcHeight);
//   let vh = window.innerHeight;
//   if (pos > vh) {
//     scrollProgress.style.opacity = 1;
//   } else {
//     scrollProgress.style.opacity = 0;
//   }
//   scrollProgress.style.background = `linear-gradient(to top, rgb(var(--color-button-text)) ${scrollValue}%, rgb(var(--color-button)) ${scrollValue}%)`;
//   let arrow = scrollProgress.querySelector("svg path");
//   arrow.style.fill = "rgb(var(--color-button-text))";
//   if (scrollValue > 50) {
//     arrow.style.filter = "invert(1)";
//     arrow.style.transition = "fill 0.3s ease, filter 0.3s ease";
//   } else {
//     arrow.style.filter = "none";
//     arrow.style.transition = "fill 0.3s ease, filter 0.3s ease";
//   }
//   scrollProgress.addEventListener("click", () => {
//     document.documentElement.style.scrollBehavior = "smooth";
//     document.documentElement.scrollTop = 0;
//   });
//   scrollProgress.style.setProperty("--scroll-value", `${scrollValue}%`);
// };
// window.onload = () => {
//   progressScrollValue();
// };
// window.onscroll = () => {
//   progressScrollValue();
// };
class WebiCollapse extends HTMLElement {
  constructor() {
    super();
    var col = this.getElementsByClassName("toggle");
    Array.from(col).forEach((ele) => {
      ele.setAttribute('tabindex', '0');
      var content = ele.nextElementSibling;
      var defaultOpen = ele.classList.contains("active");
      if (content && !defaultOpen) {
        content.style.height = '0px';
        content.setAttribute('data-collapsed', 'true');
      }
      ele.addEventListener("click", this.onSectionClick.bind(this));
      ele.addEventListener('keydown', this.handleKeyDown.bind(this));
    });
  }
  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.onSectionClick(event);
    }
  }
// new js
  onSectionClick(event) {
  var allSections = this.getElementsByClassName("toggle");

  Array.from(allSections).forEach((ele) => {
    if (ele !== event.currentTarget) {
      var content = ele.nextElementSibling;
      if (content && content.getAttribute('data-collapsed') === 'false') {
        this.collapseSection(content);
        ele.classList.remove("active");
      }
    }
  });

  event.currentTarget.classList.toggle("active");
  var content = event.currentTarget.nextElementSibling;
  if (!content) return; // Prevent error if content is null

  var isCollapsed = content.getAttribute('data-collapsed') === 'true';
  if (isCollapsed) {
    this.expandSection(content);
    content.setAttribute('data-collapsed', 'false');
  } else {
    this.collapseSection(content);
  }
}

  expandSection(element) {
    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + 'px';
    element.style.visibility = 'visible';
    element.addEventListener('transitionend', () => {
      element.removeEventListener('transitionend', this.expandSection);
      element.style.height = null;
      element.style.visibility = 'visible';
    });
    element.setAttribute('data-collapsed', 'false');
  }
  collapseSection(element) {
    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + 'px';
    element.offsetHeight;
    element.style.transition = 'height 0.3s ease';
    element.style.height = '0px';
    element.addEventListener('transitionend', () => {
      element.removeEventListener('transitionend', this.collapseSection);
      element.style.transition = '';
      element.style.height = '0px';
      element.style.visibility = 'hidden';
    });
    element.setAttribute('data-collapsed', 'true');
  }
}
customElements.define('webi-collapse', WebiCollapse);
// User js
class UserPopup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.popUpClick.bind(this));
    document.addEventListener('click', this.closePopup.bind(this));
  }
  popUpClick(event) {
    event.stopPropagation();
    this.querySelector("#userdrop").classList.toggle("hidden");
  }
  closePopup(event) {
    const userPopup = this.querySelector("#userdrop");
    if (!userPopup.contains(event.target)) {
      userPopup.classList.add("hidden");
    }
  }
}
customElements.define('user-popup', UserPopup);
// Collection page load more
class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.loadMoreProducts.bind(this));
    this.next_url = document.getElementById('product-grid').dataset.nextUrl;
    this.loadMoreBtn = this.querySelector('.button');
  }
  async getNextPage() {
    try {
      let res = await fetch(this.next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    } 
  }
  async loadMoreProducts() {
    const load_more_spinner = this.getElementsByClassName('load-more_spinner')[0];
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    let nextPage = await this.getNextPage();
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    load_more_spinner.style.display = 'none';
    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const temp = new_products;
    const new_url = productgrid.dataset.nextUrl;
    if (new_url) {
      if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'inline-flex';
    }
    this.next_url = new_url;
    let currentIndex = 0;
    while (new_products.length > currentIndex) {
      let product = new_products[currentIndex];
      if(product.classList.contains('wbimgbnrblock')) {
        currentIndex++;
        continue;
      };
      document.getElementById('product-grid').appendChild(product);
    } 
  }
}
customElements.define('load-more', LoadMore);

// Blog left sidebar Drawer Javascript
class ArticleToggle extends HTMLElement {
  constructor() {  
    super();
    this.sidebar = this.querySelector('.sidebar');
    this.toggleButton = this.querySelector('.toggle-button');
    this.closeBtn = this.querySelector('.sidebar-close');
    this.toggleButton.addEventListener('click', this.toggleSidebar.bind(this)); 
    this.closeBtn.addEventListener('click', this.closeSidebar.bind(this));
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }
  toggleSidebar() {
    this.sidebar.classList.add('active');
    document.body.classList.add("overflow-hidden");
  }
  closeSidebar() {
    this.sidebar.classList.remove('active');
    document.body.classList.remove("overflow-hidden");
  }
  handleOutsideClick(event) {
    if (this.sidebar.classList.contains('active') && !this.sidebar.contains(event.target) && !this.toggleButton.contains(event.target)) {
      this.closeSidebar();
    }
  }
} 
customElements.define('article-toggle', ArticleToggle); 
// Search Drawer Javascript
class SearchToggle extends HTMLElement {
  constructor() {  
    super();
    this.sidebar = this.querySelector('.sidebar');
    this.toggleButton = this.querySelector('.searcht-button');
    this.closeBtn = this.querySelector('.search-close');
    this.toggleButton.addEventListener('click', this.toggleSidebar.bind(this)); 
    this.closeBtn.addEventListener('click', this.closeSidebar.bind(this));
  }
  toggleSidebar() {
    this.sidebar.classList.add('active');
    document.body.classList.add("overflow-hidden");
  }
  closeSidebar() {
    this.sidebar.classList.remove('active');
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define('search-toggle', SearchToggle); 
// Lookbook Active outside
class LookBook extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('div.wblookbook .wblookbtn').forEach((lookbookpoint) => {
      lookbookpoint.addEventListener('click', this.onButtonClick.bind(this));
    });
  }
  onButtonClick(blockId) {
    var blockId = event.currentTarget.dataset.blobkid;
    this.querySelectorAll('li').forEach((lookbookproduct) => {
      if(lookbookproduct.getAttribute('data-blobkid') == blockId)
        lookbookproduct.classList.add('active');
      else
        lookbookproduct.classList.remove('active');
    });
    this.querySelectorAll('div.wblookbook .wblookbtn').forEach((lookbookpoint) => {
      if(lookbookpoint.getAttribute('data-blobkid') == blockId)
         lookbookpoint.classList.add('active');
      else
         lookbookpoint.classList.remove('active');
    });
  }
}
customElements.define('look-book', LookBook);
// on click remove content on video
document.querySelectorAll('.banner-content-remove').forEach((close) => {
  close.addEventListener('click', (event) => {
    const parentElement = event.currentTarget.closest('.video_banner_box');
    if (parentElement) {
      parentElement.remove();
    }
  });
});
// Variant hover
class ColorSwatch extends VariantSelects {
  constructor() { 
    super();
    // const fieldsets = Array.from(this.querySelectorAll('fieldset label'));
    this.querySelectorAll('fieldset label').forEach((ele)=>{
      ele.addEventListener('mouseenter', this.onVariantChangeHover.bind(this));
      ele.addEventListener('click', this.onLabelClick.bind(this));
    }) 
  }
  onLabelClick(event){
    if(event.target.dataset.href){
      window.location.href = event.target.dataset.href;
    }
  }
  updatelabelDataset(ele){
    let href = ele.dataset.href;
    let optionValuesStr = '';
    if (this.selectedOptionValues.length) {
          optionValuesStr=this.selectedOptionValues.join(',');
    }
    if(href.indexOf('?option_values=') > -1){
      href = (href.substring(0, href.indexOf('?option_values=')+15) + optionValuesStr)
    }else{
      href += ("?option_values="+ optionValuesStr)
    }
    ele.dataset.href = href; 
  }
  onVariantChangeHover(event){
    // this.updatelabelDataset(event.target);
    this.querySelector('#'+event.target.getAttribute('for')).click();
    this.updatelabelDataset(event.target);
  }
}
customElements.define('color-swatch', ColorSwatch);
class WBCardVariant extends HTMLElement {
  constructor() {
    super();
    this.previousHeight = null;
  }
  connectedCallback() {
    this.setHeaderHeight();
  }
  setHeaderHeight() {
    const variantPopupHover = this.querySelector('.variant__popup_hover');
    const wbCartQuick = this.querySelector('.wbcart_quick');
    const variantPopupHoverHeight = variantPopupHover ? variantPopupHover.offsetHeight : 0;
    const wbCartQuickHeight = wbCartQuick ? wbCartQuick.offsetHeight : 0;
    const additionalHeight = variantPopupHover ? 27 : 0;
    const newBeForeInfo = variantPopupHoverHeight + wbCartQuickHeight + additionalHeight;
    this.style.marginTop = `calc(-${newBeForeInfo}px - var(--image-padding))`;

  }
}
customElements.define('wb-card-variant', WBCardVariant);
// compare image
document.addEventListener('DOMContentLoaded', function () {
  var comparisonSliders = document.querySelectorAll(".comparison-slider");
  if (comparisonSliders.length > 0) {
      comparisonSliders.forEach(function (compSlider) {
          var compSliderWidth = compSlider.offsetWidth + "px";
          compSlider.querySelector(".resize .compare__image").style.width = compSliderWidth;
          drags(compSlider.querySelector(".divider"), compSlider.querySelector(".resize"), compSlider);
      });
      window.addEventListener("resize", function () {
          comparisonSliders.forEach(function (compSlider) {
              var compSliderWidth = compSlider.offsetWidth + "px";
              compSlider.querySelector(".resize .compare__image").style.width = compSliderWidth;
          });
      });
  }
});
function drags(dragElement, resizeElement, container) {
  var touched = false;
  window.addEventListener('touchstart', function () {
      touched = true;
  });
  window.addEventListener('touchend', function () {
      touched = false;
  });
  dragElement.addEventListener("mousedown", startDragging);
  dragElement.addEventListener("touchstart", startDragging);
  function startDragging(e) {
      e.preventDefault();
      dragElement.classList.add("draggable");
      resizeElement.classList.add("resizable");
      var startX = e.pageX || e.touches[0].pageX;
      var dragWidth = dragElement.offsetWidth;
      var posX = dragElement.offsetLeft + dragWidth - startX;
      var containerOffset = container.offsetLeft;
      var containerWidth = container.offsetWidth;
      var minLeft = containerOffset + 10;
      var maxLeft = containerOffset + containerWidth - dragWidth - 10;
      function dragMove(e) {
        if (!touched) {
            e.preventDefault();
        }
        var moveX = e.pageX || (e.touches && e.touches.length > 0 ? e.touches[0].pageX : undefined);
        var leftValue = moveX + posX - dragWidth;
        if (leftValue < minLeft) {
            leftValue = minLeft;
        } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
        }
        var widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth) + "%";
        dragElement.style.left = widthValue;
        resizeElement.style.width = widthValue;
    }
      function dragEnd() {
          dragElement.classList.remove("draggable");
          resizeElement.classList.remove("resizable");
          document.removeEventListener("mousemove", dragMove);
          document.removeEventListener("mouseup", dragEnd);
          document.removeEventListener("touchmove", dragMove);
          document.removeEventListener("touchend", dragEnd);
          document.removeEventListener("touchcancel", dragEnd);
      }
      document.addEventListener("mousemove", dragMove);
      document.addEventListener("mouseup", dragEnd);
      document.addEventListener("touchmove", dragMove);
      document.addEventListener("touchend", dragEnd);
      document.addEventListener("touchcancel", dragEnd);
  }
}
// lookbook grid slider
document.addEventListener("DOMContentLoaded", function() {
  const lookbookComponents = document.querySelectorAll('look-book');
  lookbookComponents.forEach(function(component) {
      const lookbookButtons = component.querySelectorAll('.wblookbook');
      lookbookButtons.forEach(function(button) {
          button.addEventListener('click', function() {
              const buttonId = this.getAttribute('data-id');
              const correspondingTarget = component.querySelector(`.slider-counter__link[data-id='${buttonId}']`);
              if (correspondingTarget) {
                  correspondingTarget.click();
              }
          });
      });
  });
});
document.addEventListener('DOMContentLoaded', function() {
  function triggerSlideshowPrevButton() {
    const customPrevButton = document.querySelector('.custom__button .slider-button--prev');
    const slideshowPrevButtons = document.querySelectorAll('.slide-trigger .slider-button--prev');
    if (customPrevButton && slideshowPrevButtons.length > 0) {
      customPrevButton.addEventListener('click', function() {
        slideshowPrevButtons.forEach(button => button.click());
      });
    }
  }
  function triggerSlideshowNextButton() {
    const customNextButton = document.querySelector('.custom__button .slider-button--next');
    const slideshowNextButtons = document.querySelectorAll('.slide-trigger .slider-button--next');
    if (customNextButton && slideshowNextButtons.length > 0) {
      customNextButton.addEventListener('click', function() {
        slideshowNextButtons.forEach(button => button.click());
      });
    }
  }
  triggerSlideshowPrevButton();
  triggerSlideshowNextButton();
});
// collection-list marquee position
document.querySelectorAll('[id^="hoverBox--"]').forEach((boxmain) => { 
  const blockId = boxmain.id.split('--')[1];
  const marqueemain = document.getElementById(`marqueemainText--${blockId}`);
  if (marqueemain) {
    boxmain.addEventListener('mousemove', (event) => {
      const rect = boxmain.getBoundingClientRect();
      let y = event.clientY - rect.top;
      let percentage = (y / rect.height) * 95;
      percentage = Math.max(0, Math.min(percentage, 95));
      // marqueemain.style.display = 'block';
      marqueemain.style.top = `${percentage}%`;
    });
    // boxmain.addEventListener('mouseleave', () => {
    //   marqueemain.style.opacity = '';
    // });
  }
});
// Quick view and Variant view js 
class WbQuickView extends HTMLElement {
  constructor() { 
    super();
     this.addEventListener('click', this.wbPopUp.bind(this));
  }
  wbPopUp(e){
    e.target.classList.add('loading');
    const spinner = e.target.querySelector('.loading-overlay__spinner');
    if (spinner) {
        spinner.classList.remove('hidden');
    }
    e.target.setAttribute('disabled', 'true');
    fetch(e.target.dataset.url?.split('?')[0] + '?view=' + e.target.dataset.template + (e.target.dataset.variantid ? '&variant=' + e.target.dataset.variantid : ''))
        .then(response => response.text())
        .then(data => {
            if (!data) return;
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(data, 'text/html');
            const html = htmlDoc.querySelector('[data-html="content"]').innerHTML;
            const modalSelector = document.querySelector(".js-quick_view");
            if (modalSelector) {
              document.body.classList.add('overflow-hidden', 'modal_view');
              modalSelector.innerHTML = html;
            }
            e.target.classList.remove('loading');
            if (spinner) {
                spinner.classList.add('hidden');
            }
            e.target.removeAttribute('disabled');
        })
    .catch(error => console.error('Error:', error));
  }
}
customElements.define('wb-quick-view', WbQuickView);
class WbModal extends HTMLElement {
  constructor() { 
      super();
      this.closeEl = this.querySelector(".modal__close");
  }
  connectedCallback() {
    const _ = this;
    this.closeEl.addEventListener('click', this.close.bind(this));
    if(this.cartBtnElement){
      this.cartBtnElement.addEventListener('click', this.close.bind(this));
    }
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        _.close();
      }
    });
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.common_modal') && !event.target.closest('modal-dialog.product-popup-modal')) {
         _.close();
      }
    });
  }
  close() {
    const _ = this;
    this.classList.add("close_popup");
    setTimeout(function() {
      _.remove();
      document.body.classList.remove('overflow-hidden', 'modal_view');
    }, 80);
  }
  get cartBtnElement(){
    return this.querySelector(".product-form__submit");
  }
}
customElements.define('wb-modal', WbModal);
// Carousel
class SliderCarousel extends HTMLElement {
  constructor() {
    super();
    let optionsData = {};
    let defaults = {};
    let autoplay = false;
    if(this.dataset.sectionSetting){
      const sectionSetting = JSON.parse(this.dataset.sectionSetting);
      const space = +this.dataset.spacingGridHorizontal;
      const spacemobile =  +this.dataset.spacingGridHorizontal/2;
      optionsData = {
        slidesPerView: sectionSetting.columns_desktop ? sectionSetting.columns_desktop : 1,
        spaceBetween: space,
        loop: false,
        dragClickables: false,
        pagination: {
          clickable: 'true',
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: spacemobile,
          },
          768: {
            slidesPerView: sectionSetting.columns_desktop,
            spaceBetween: space,
          }
        }
      };
      if(this.dataset.breakpoints){
        const breakpoints = JSON.parse(this.dataset.breakpoints)
        for (const key in breakpoints) {
          if(key ==0){
            let obj = {
              slidesPerView: breakpoints[key],
              spaceBetween: spacemobile,
            }
            optionsData['breakpoints'][key] = obj
          }else{
            let customspaceBetween = space
            let breakpointsKey = key
            if(key.indexOf('m') > -1){ 
              breakpointsKey = key.split('-')[1]
              customspaceBetween = spacemobile
            }
            let obj = {
              slidesPerView: breakpoints[key],
              spaceBetween: customspaceBetween,
            }
            optionsData['breakpoints'][breakpointsKey] = obj
          }
        }
      }
      if(sectionSetting.auto_rotate == true){
        autoplay = true;
        optionsData['autoplay'] = {
          delay: sectionSetting.change_slides_speed * 1000,
          disableOnInteraction: false,
        };
      }
      optionsData['navigation'] = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }
    this.options = {
      ...defaults,
      ...optionsData
    };
  }
  connectedCallback() {
    new Swiper(this.querySelector('.swiper'), this.options);
  }
}
customElements.define('slider-carousel', SliderCarousel); 
// Carousel
// class SliderCarousel extends HTMLElement {
//   constructor() {
//     super();
//     this.Carousel = null;
//     this.elements = {
//       slider: this.querySelector('.swiper'),
//       prevButton: this.querySelector('.swiper-button-prev'),
//       nextButton: this.querySelector('.swiper-button-next'),
//     };


//     let sectionSetting;
//     if (this.dataset.sectionSetting) {
//       sectionSetting = JSON.parse(this.dataset.sectionSetting);
//     }

//     this.config = {
//       isDesktopSlider: sectionSetting.layout == "slider",
//       itemDesktop: Number(sectionSetting.columns_desktop),
//       spacingDesktop: Number(this.dataset.spacingGridHorizontal),
//       isMobileSlider: sectionSetting.swipe_on_mobile,
//       itemMobile:  Number(sectionSetting.columns_mobile) || 2,
//       spacingMoblie: Number(this.dataset.spacingGridHorizontal) / 2
//     };

//     this.options = {
//       slidesPerView: this.config.itemMobile,
//       spaceBetween: this.config.spacingMoblie,
//       loop: false,
//       dragClickables: false,
//       pagination: {
//         clickable: 'true',
//       }
//     };

//     if (sectionSetting.auto_rotate === true) {
//       this.options.autoplay = {
//         delay: Number(sectionSetting.change_slides_speed) * 1000,
//         disableOnInteraction: false,
//       };
//     }

//     if (this.elements.nextButton && this.elements.prevButton) {
//       this.options.navigation = {
//         nextEl: this.elements.nextButton,
//         prevEl: this.elements.prevButton
//       };
//     }

//     this.init();
//   }
//   init() {
//     if (window.matchMedia('(max-width: 992px)').matches && this.config.isMobileSlider) {
//       this.initCarousel();
//       this.updateMobileSettings();
//     }

//     if (!window.matchMedia('(max-width: 992px)').matches && this.config.isDesktopSlider) {
//       this.initCarousel();
//       this.updateDesktopSettings();
//     }

//     const mql2 = window.matchMedia('(max-width: 992px)');
//     mql2.onchange = (e) => {
//       if (e.matches) {
//         if (this.config.isMobileSlider) {
//           if (!this.Carousel) this.initCarousel();
//           this.updateMobileSettings();
//         } else {
//           this.destory();
//         }
//       } else {
//         if (this.config.isDesktopSlider) {
//           if (!this.Carousel) this.initCarousel();
//           this.updateDesktopSettings();
//         } else {
//           this.destory();
//         }
//       }
//     }
//   }

//   initCarousel() {
//     if (!this.Carousel) {
//       this.Carousel = new Swiper(this.elements.slider, this.options);
//     }
//   }

//   updateDesktopSettings() {
//     if (!this.Carousel) return;

//     this.Carousel.params.breakpoints = {
//         992: {
//           slidesPerView: this.config.itemDesktop,
//           spaceBetween: this.config.spacingDesktop
//         }
//     };
//     this.Carousel.update();
//   }

//   updateMobileSettings() {
//     if (!this.Carousel) return;

//     this.Carousel.params.slidesPerView = this.config.itemMobile;
//     this.Carousel.params.spaceBetween = this.config.spacingMoblie;
//     this.Carousel.update();
//   }

//   destory() {
//     if (this.Carousel && typeof this.Carousel.destroy === 'function') {
//       this.Carousel.destroy(true, true);
//        this.Carousel = null;
//     }
//   }
// }
// customElements.define('slider-carousel', SliderCarousel);
